import { BrandInfo } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/BrandInfo";
import { DebugInfoSection } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/DebugInfoSection";
import { SearchProductImageClient } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/search/SearchProductImageClient";
import { PriceWithClientFormatMoney } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/PriceWithClientFormatMoney";
import { SearchProductLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/SearchProductLink";
import { MaybeSearchProductTileClickProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProvider";
import { ProductTileContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileContainer/ProductTileContainer";
import { ProductTileContextProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContextProvider";
import { DiscoverProductTileProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/DiscoverProductTileProps";
import { whichBatch10ProductTilesVariant } from "@faire/retailer-visitor-shared/settings/useSettingBatch10ProductTiles";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

import { LoggedOutProductName } from "./__internal__/components/LoggedOut/LoggedOutProductName";
import { LoggedOutProductTileSwatches } from "./__internal__/components/LoggedOut/LoggedOutProductTileSwatches";
import { LoggedOutProductTileTrackingWrapper } from "./__internal__/components/LoggedOut/LoggedOutProductTileTrackingWrapper";
import { LoggedOutProductTileUpperContainer } from "./__internal__/components/LoggedOut/LoggedOutProductTileUpperContainer";
import { LoggedOutTopBadges } from "./__internal__/components/LoggedOut/LoggedOutTopBadges";
import { LoggedOutUnlockWholesalePriceLink } from "./__internal__/components/LoggedOut/LoggedOutUnlockWholesalePriceLink";

export const LoggedOutSearchProductTile = ({
  data,
}: {
  data: DiscoverProductTileProps;
}) => {
  const {
    productTileImageClientProps,
    productTileTrackingWrapperProps,
    productTileDebugInfoProps,
    productTileTopBadgesProps,
    productTileClickProviderProps,
    brand,
    priceTextProps,
    batch10ProductTilesVariant,
    productName,
    productOptionDetails,
    brandInfoData,
  } = data;

  const {
    isBatch10ProductTilesControl,
    isBatch10ProductTilesV2orV3,
    isBatch10ProductTilesV3,
  } = whichBatch10ProductTilesVariant(batch10ProductTilesVariant);

  return (
    <ProductTileContextProvider brandToken={brand?.token} brand={brand}>
      <LoggedOutProductTileTrackingWrapper
        data={productTileTrackingWrapperProps}
      >
        <MaybeSearchProductTileClickProvider
          data={productTileClickProviderProps}
        >
          <ProductTileContainer>
            <LoggedOutProductTileUpperContainer>
              <SearchProductLink data={productTileClickProviderProps}>
                <SearchProductImageClient data={productTileImageClientProps} />
              </SearchProductLink>
              <LoggedOutTopBadges data={productTileTopBadgesProps} />
              <DebugInfoSection data={productTileDebugInfoProps} />
            </LoggedOutProductTileUpperContainer>
            <Spacer size={{ mobileAndAbove: "1x", tabletAndAbove: 12 }} />
            {isBatch10ProductTilesV2orV3 ? (
              <BrandInfo
                data={brandInfoData}
                batch10ProductTilesVariant={batch10ProductTilesVariant}
              />
            ) : null}

            <SearchProductLink data={productTileClickProviderProps}>
              <LoggedOutProductName
                productName={productName}
                className={
                  !isBatch10ProductTilesControl ? "line-clamp-1" : undefined
                }
              />
              <PriceWithClientFormatMoney
                {...priceTextProps}
                batch10ProductTilesVariant={batch10ProductTilesVariant}
              />
              <LoggedOutProductTileSwatches
                optionDetails={productOptionDetails}
              />
            </SearchProductLink>
            {isBatch10ProductTilesControl ? <Spacer size="1x" /> : null}
            {!isBatch10ProductTilesV2orV3 ? (
              <BrandInfo
                data={brandInfoData}
                batch10ProductTilesVariant={batch10ProductTilesVariant}
              />
            ) : null}
            {!isBatch10ProductTilesControl ? (
              <SearchProductLink data={productTileClickProviderProps}>
                <LoggedOutUnlockWholesalePriceLink
                  hideLockIcon={isBatch10ProductTilesV3}
                />
              </SearchProductLink>
            ) : null}
          </ProductTileContainer>
        </MaybeSearchProductTileClickProvider>
      </LoggedOutProductTileTrackingWrapper>
    </ProductTileContextProvider>
  );
};
